import { useSelector } from '@/store';
import { useApolloClient } from '@apollo/client';
import ModalActions from '@components/modal/ModalActions';
import { setDGAReportsChartModal } from '@features/dga/slices/dgaSlice';
import { Dialog } from '@mui/material';
import { Suspense, type FC } from 'react';
import { useDispatch } from 'react-redux';
import { Fallback } from './ChartFallback';
import { ChartContent } from './ChartContent';


const DGAReportsChartModal: FC = () => {
  const dispatch = useDispatch();
  const { reportsChartModal } = useSelector((state) => state.dga_store);

  const client = useApolloClient()

  const onClose = () => {
    if (reportsChartModal.open) {
      client.cache.evict({
        id: `DeviceDGA:${reportsChartModal.deviceId}`,
        fieldName: 'reports',
      });
      client.cache.gc();
    }
    dispatch(
      setDGAReportsChartModal({
        open: false,
      }),
    );
  };

  return (
    <Dialog onClose={onClose} open={reportsChartModal.open} maxWidth="md" fullWidth>
      <Suspense fallback={<Fallback onClose={onClose} />}>
        {reportsChartModal.open && (
          <ChartContent
            onClose={onClose}
            deviceId={reportsChartModal.deviceId}
          />
        )}
      </Suspense>
      <ModalActions onClose={onClose} />
    </Dialog>
  );
};

export default DGAReportsChartModal;
